import { Injectable } from '@angular/core';
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http"; 
import { Observable, Subject } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class ViewLogService {

  constructor(private http: HttpClient) { }

  private _providerbase: string = environment.apiURL;

  getData(endpoint: string, filter: string): Observable<any> {
    let subject = new Subject<any>();
    this.http.get(this._providerbase + endpoint + filter, { observe: 'response' }).subscribe(resp => {
      subject.next({
        'data': resp.body,
        'totalPages': resp.headers.get('X-Pagination-Page-Count'),
        'totalCount': resp.headers.get('X-Pagination-Total-Count')
      })
    });
    return subject.asObservable();
  }

}
